export const CONNECTION_WORKSPACE_CONFLICT_MESSAGE =
  "This account is already connected to another WaveGen workspace, so we didn’t connect it here. To move it, disconnect it in that workspace first. No access to that workspace? Contact support.";

const CONNECTION_ERROR_MESSAGES: Record<string, string> = {
  youtube_no_channel:
    "No YouTube channel was found for this Google account. Please create a channel at youtube.com, then try connecting again.",
  youtube_publish_permission_missing:
    "YouTube didn't grant WaveGen permission to publish videos. We didn't save this connection. Try connecting again and approve all requested permissions.",
  youtube_permission_check_failed:
    "We couldn't verify YouTube's publishing access, so we didn't save this connection. Please try again.",
  facebook_no_pages:
    "Facebook didn't share any Pages with WaveGen. Connect again, choose Edit settings in Facebook's window, and select your Pages (and the Business that owns them, if asked).",
  facebook_page_not_shared:
    "Facebook isn't sharing this Page with WaveGen. Reconnect, choose Edit settings in Facebook's window, and select the Page. Keep your other Pages selected too.",
  access_denied:
    "Connection cancelled. You declined to grant access on the provider's consent screen.",
  instagram_publish_permission_missing:
    "Instagram didn't grant WaveGen permission to publish. We didn't save this connection. Try connecting again and allow content publishing.",
  instagram_permission_check_failed:
    "We couldn't verify Instagram's publishing access, so we didn't save this connection. Please try again.",
  limit:
    "You've reached your plan's connection limit. Disconnect an account or upgrade to add more.",
  connection_workspace_conflict: CONNECTION_WORKSPACE_CONFLICT_MESSAGE,
  connection_network_error:
    "We couldn't reach Wavegen to start the connection. Check your internet connection and try again. If it keeps happening, please try again later.",
  connection_failed: "Connection failed. Please try again.",
};

export function getConnectionErrorMessage(errorCode: string): string {
  return (
    CONNECTION_ERROR_MESSAGES[errorCode] ??
    CONNECTION_ERROR_MESSAGES.connection_failed
  );
}
